import { call, put, takeLatest } from 'redux-saga/effects';
import { baseApi } from '@/lib/api';
import {
  fetchUploadedFilesRequest,
  fetchUploadedFilesSuccess,
  fetchUploadedFilesFailure,
} from '../slices/uploadedFilesSlice';
import { getUploadFile } from '@/api/products';

function* fetchUploadedFilesSaga() {
  try {
    const response = yield call(getUploadFile);
    yield put(fetchUploadedFilesSuccess(response));
  } catch (error) {
    yield put(fetchUploadedFilesFailure(error instanceof Error ? error.message : 'Failed to fetch files'));
  }
}

export function* uploadedFilesSaga() {
  yield takeLatest(fetchUploadedFilesRequest.type, fetchUploadedFilesSaga);
}